import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'api/web/v1/site/login',
        method: 'POST',
        data: credentials,
        isFormData: true,
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;
